import { FC } from 'react'

import { Loader } from 'components'
import { Navigate } from 'react-router-dom'
import { Routes } from 'common/constants'

import { Product } from '../../product-br'
import { useUnitedStatesMeansOfCommunicationAdapter } from '../../product-br/components/means-of-communication/hooks'
import { useProduct } from '../hooks/useProduct'

export const ProductUs: FC = () => {
  const { entity, isContentLoading, isErrorOrInactive, validProductId, productContent } =
    useProduct()
  const communications = useUnitedStatesMeansOfCommunicationAdapter({
    communications: productContent?.marketingNotificationsSection.communications ?? {},
  })

  if (!entity) return null

  if (isContentLoading) return <Product screen={{ status: 'loading', fallback: <Loader /> }} />

  if (isErrorOrInactive || productContent === undefined) {
    return <Product screen={{ status: 'error', fallback: <Navigate to={Routes.ERROR} /> }} />
  }

  return (
    <Product
      screen={{
        status: 'ready',
        productContent,
        productId: validProductId,
        communications,
      }}
    />
  )
}
